import { Team_NAMES } from "./teams";

export interface PlayerCardType {
  id: number;
  name: string;
  img: string;
  lastgame: PlayerGame;
}

export interface PlayerCardStats {
  value: number | string;
  description: string;
}

export enum WP_BLOCK_TYPE {
  PLAYER_CARD,
  RAW,
  IMAGE,
}

export interface ParsedWPBlock {
  content?: string;
  data?: object;
  type: WP_BLOCK_TYPE;
  category?: string;
}

export interface PlayerGame {
  id: string;
  player: string;
  season: string;
  round: string;
  points: string;
  price: string;
  total_points: string;
  games: string;
  total_games: string;
  price_change: string;
  total_price_change: string;
  minutes_played: string;
  total_minutes_played: string;
  tries: string;
  total_tries: string;
  try_assists: string;
  total_try_assists: string;
  try_contributions: string;
  total_try_contributions: string;
  goals: string;
  total_goals: string;
  missed_goals: string;
  total_missed_goals: string;
  field_goals: string;
  total_field_goals: string;
  missed_field_goals: string;
  tackles: string;
  total_tackles: string;
  missed_tackles: string;
  total_missed_tackles: string;
  tackle_busts: string;
  total_tackle_busts: string;
  forced_drop_outs: string;
  total_forced_drop_outs: string;
  effective_offloads: string;
  total_effective_offloads: string;
  ineffective_offloads: string;
  total_ineffective_offloads: string;
  line_breaks: string;
  total_line_breaks: string;
  line_break_assists: string;
  total_line_break_assists: string;
  a40_20: string;
  total_40_20: string;
  kick_regather_break: string;
  total_kick_regather_break: string;
  hitups_over_8m: string;
  total_hitups_over_8m: string;
  hitups_under_8m: string;
  total_hitups_under_8mholdups_in_goal: string;
  total_holdups_in_goal: string;
  intercepts_taken: string;
  total_intercepts_taken: string;
  dead_kicks: string;
  total_dead_kicks: string;
  penalties: string;
  total_penalties: string;
  errors: string;
  total_errors: string;
  sendoffs: string;
  total_sendoffs: string;
  venue: string;
  s60_plus: string;
  base_points: string;
  scoring_points: string;
  negative_play_points: string;
  create_points: string;
  evade_points: string;
  position: string;
  team: string;
  opposition: string;
  homescore: string;
  awayscore: string;
  hometeam: string;
  awayteam: string;
  date: string;
  posrank: string;
  posrdrank: string;
  scbe: string;
  totalOwnership: string;
  ownerShipPercentage: string;
  nextRoundPredictedPoints: string;
  nextRoundPredictedPrice: string;
}
